// extracted by mini-css-extract-plugin
module.exports = {"children":"layout_children__1Zx2y"};